import styled, { css } from 'styled-components';
import { StatusTagType } from '../ThemeProvider/types';

export const TagContainer = styled.div<{ status: StatusTagType; fullWidth: boolean }>`
  align-items: center !important;
  border: 1px solid;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  font-family: 'Mulish', sans-serif;
  font-size: 14px;
  justify-content: center !important;
  padding: 4px 12px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};

  ${({ theme, status }) => css`
    background-color: ${theme.status[status].opacity};
    border-color: ${theme.status[status].color};
    color: ${theme.gray2D};
  `}
`;
